import List from './StudentList'
import View from './StudentView'
const exportObj = {
    List, View
}

export default exportObj